import { render } from "./BirthdayLayout.vue?vue&type=template&id=a8daa1e0&scoped=true"
import script from "./BirthdayLayout.vue?vue&type=script&lang=js"
export * from "./BirthdayLayout.vue?vue&type=script&lang=js"

import "./BirthdayLayout.vue?vue&type=style&index=0&id=a8daa1e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8daa1e0"]])

export default __exports__